import PQueue from "p-queue";

const requestQueue = new PQueue({ concurrency: 5 });

export default requestQueue;
